module.exports = __webpack_public_path__ + "static/img/btn-back.0dc113cd.png";